!function () {
  "use strict";

  if (customElements.get("rewards-customer-form")) return;

  var ID_TYPE_BY_ODOO_ID = { 5: "cedula", 4: "ruc", 2: "pasaporte" };

  customElements.define(
    "rewards-customer-form",
    class extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.messageEl = this.querySelector("[data-rewards-form-message]");
        this.successEl = this.querySelector("[data-rewards-form-success]");
        this.successTextEl = this.querySelector("[data-rewards-form-success-text]");
        this.resetButton = this.querySelector("[data-rewards-form-reset]");
        this.submitButton = this.form
          ? this.form.querySelector("button[type=submit]")
          : null;

        if (this.form) {
          this.form.addEventListener("submit", this.onSubmit.bind(this));
        }
        if (this.resetButton) {
          this.resetButton.addEventListener("click", this.onReset.bind(this));
        }

        this.onStatusEvent = this.onStatusEvent.bind(this);
        document.addEventListener("rewards-club:status", this.onStatusEvent);
      }

      onStatusEvent(event) {
        var data = event.detail;
        if (!data || !data.found || !data.profile || !this.form) return;
        var profile = data.profile;

        var birthdayInput = this.form.querySelector("[name=birthday]");
        if (birthdayInput && !birthdayInput.value && profile.birthday) {
          birthdayInput.value = profile.birthday;
        }

        var idNumberInput = this.form.querySelector("[name=id_number]");
        if (idNumberInput && !idNumberInput.value && profile.id_number) {
          idNumberInput.value = profile.id_number;
        }

        var idTypeSelect = this.form.querySelector("[name=id_type]");
        if (idTypeSelect && profile.id_type_id && ID_TYPE_BY_ODOO_ID[profile.id_type_id]) {
          idTypeSelect.value = ID_TYPE_BY_ODOO_ID[profile.id_type_id];
        }

        var phoneInput = this.form.querySelector("[name=phone]");
        if (phoneInput && !phoneInput.value && profile.phone) {
          phoneInput.value = profile.phone;
        }
      }

      onSubmit(event) {
        event.preventDefault();

        if (!this.form.checkValidity()) {
          this.form.classList.add("is-invalid");
          this.form.reportValidity();
          setTimeout(() => {
            this.form.classList.remove("is-invalid");
          }, 400);
          return;
        }

        var webhookUrl = this.dataset.webhookUrl;
        if (!webhookUrl) return;

        var formData = new FormData(this.form);
        var payload = {
          first_name: (formData.get("name") || "").trim(),
          last_name: "",
          email: (formData.get("email") || "").trim(),
          phone: (formData.get("phone") || "").trim(),
          birthday: formData.get("birthday") || "",
          id_type: formData.get("id_type") || "",
          id_number: (formData.get("id_number") || "").trim()
        };

        this.setLoading(true);
        this.hideMessage();

        var self = this;
        fetch(webhookUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            return response
              .json()
              .catch(function () {
                return {};
              })
              .then(function (data) {
                return { ok: response.ok, data: data };
              });
          })
          .then(function (result) {
            if (result.ok && result.data && result.data.success !== false) {
              self.showSuccess(
                self.dataset.successMessage || "Tus datos se guardaron correctamente."
              );
            } else {
              self.showMessage(
                (result.data && result.data.message) ||
                  self.dataset.errorMessage ||
                  "No pudimos guardar tus datos.",
                false
              );
            }
          })
          .catch(function () {
            self.showMessage(
              self.dataset.errorMessage || "No pudimos guardar tus datos.",
              false
            );
          })
          .finally(function () {
            self.setLoading(false);
          });
      }

      onReset() {
        if (this.successEl) this.successEl.hidden = true;
        if (this.form) {
          this.form.hidden = false;
          this.form.classList.add("is-entering");
          setTimeout(() => {
            this.form.classList.remove("is-entering");
          }, 400);
        }
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;
        this.submitButton.disabled = isLoading;
        this.submitButton.classList.toggle("is-loading", isLoading);
      }

      showSuccess(text) {
        if (this.form) this.form.hidden = true;
        if (this.successEl) this.successEl.hidden = false;
        if (this.successTextEl) this.successTextEl.textContent = text;
      }

      showMessage(text, isSuccess) {
        if (!this.messageEl) return;
        this.messageEl.textContent = text;
        this.messageEl.hidden = false;
        this.messageEl.classList.toggle("rewards-customer-form__message--success", !!isSuccess);
        this.messageEl.classList.toggle("rewards-customer-form__message--error", !isSuccess);
      }

      hideMessage() {
        if (!this.messageEl) return;
        this.messageEl.hidden = true;
        this.messageEl.textContent = "";
      }
    }
  );
}();
